import * as React from 'react';
import { SelectOption } from 'formComponents/Select/types';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import { branchenSelector } from 'store/lookups/selector';
import { callApi, Controller } from './useApi';

export interface Branche {
    nr: number;
    text: string;
}

export const defaultBranche: Branche = {
    nr: 0,
    text: '',
};

export function useBranchenAsOptions(addEmpty = false): SelectOption[] {
    const branchen = useSelector(branchenSelector);

    return React.useMemo<SelectOption[]>(() => {
        const list = branchen.map((branche) => ({ value: branche.nr.toString(), label: branche.text }));
        if (addEmpty) {
            list.push({ value: '-1', label: '(keine Eintrag)' });
        }
        return list;
    }, [branchen, addEmpty]);
}

export async function addBranche(branche: Branche): Promise<void> {
    return callApi<void>(Controller.branche + '/add', { branche });
}

export async function updateBranche(branche: Branche): Promise<void> {
    return callApi<void>(Controller.branche + '/update', { branche });
}

export async function deleteBranche(branche: Branche): Promise<void> {
    return callApi<void>(Controller.branche + '/update', { branche });
}
